// Lightweight environment snapshot for the Contact widget's "include
// diagnostic info" checkbox. Deliberately not the full report DebugPanel's
// copyDiagnosticReport() builds (chop families, filter settings, live
// mixer levels) - that's sequence-editing detail a support email rarely
// needs, and pulling it in here would mean loading player/audio-engine
// internals on every page the Contact button floats on, not just the
// player.
export async function buildDiagnosticSummary(): Promise<string> {
  const project = useProjectStore()
  const engine = useAudioEngine()
  const route = useRoute()

  const lines = [
    `MPC1000.com diagnostic info`,
    `generated: ${new Date().toISOString()}`,
    `app version: ${useRuntimeConfig().public.appVersion}`,
    `page: ${route.fullPath}`,
    `browser: ${navigator.userAgent}`,
    `viewport: ${window.innerWidth}x${window.innerHeight}`,
    `project loaded: ${project.projectName ?? '(none)'}`,
  ]

  if (engine.decodeWarnings.length) {
    lines.push(`decode warnings: ${engine.decodeWarnings.length}`)
    for (const w of engine.decodeWarnings.slice(0, 10)) lines.push(`  - ${w.name}: ${w.error}`)
  }

  try {
    const { LDObserve } = await import('@launchdarkly/observability')
    // getSessionURL is real at runtime, but highlight.run ships two
    // conflicting _LDObserve type declarations and the one that wins here
    // omits it - a package typing gap, not an app bug.
    const sessionUrl = await (LDObserve as unknown as { getSessionURL(): Promise<string> }).getSessionURL()
    if (sessionUrl) lines.push(`session replay: ${sessionUrl}`)
  } catch {
    // Observability may not have finished loading yet (it starts on
    // requestIdleCallback) - fine to omit, not worth blocking on.
  }

  return lines.join('\n')
}
